import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SingleCardModule } from 'src/app/layouts';
import { Router } from '@angular/router';

@Component({
	selector: 'app-unauthenticated-content',
	template: `
		<app-single-card [title]="title" [description]="description">
			<router-outlet></router-outlet>
		</app-single-card>
	`,
	styles: [`
		:host {
			width: 100%;
			height: 100%;
		}
	`],
})
export class UnauthenticatedContentComponent {
	constructor(private router: Router) { }

	get description(): string {
		const url = this.router.url;
		if (url.startsWith('/auth/create-password/'))
			return 'Kérjük, adja meg az új jelszavát.';
		if (url === '/auth/reset-password')
			return 'Kérjük, adja meg a regisztrációhoz használt e-mail címet, és e-mailben küldünk egy linket a jelszó visszaállításához.';
		if (url === '/auth/change-password')
			return 'Kérjük, változtassa meg a jelszavát.';
		if (url === '/auth/two-factor-code')
			return 'Kérjük, adja az authenticator alkalmazásban lévő kódot.';
		return '';
	}

	get title(): string {
		const url = this.router.url;
		if (url.startsWith('/auth/create-password/'))
			return 'Új jelszó létrehozása';
		if (url === ('/auth/reset-password'))
			return 'Új jelszó igénylése';
		if (url === ('/auth/login'))
			return 'Bejelentkezés';
		if (url === ('/auth/change-password'))
			return 'Jelszó módosítása';
		if (url === '/auth/two-factor-code')
			return 'Két lépcsős azonsítás';
		return '';
	}
}
@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		SingleCardModule,
	],
	declarations: [UnauthenticatedContentComponent],
	exports: [UnauthenticatedContentComponent],
})
export class UnauthenticatedContentModule { }
